export const FAQList = [
  {
    id: 1,
    title: "آزتو چیست؟",
    mainText:
      "آزتو، مجموعه‌ای از آزمایشگاه‌های علمی و درسی مجازی تحت وب و آنلاین می‌باشد که منطبق با محتوای آموزشی مصوب وزارت آموزش و پرورش و وزارت علوم است. این آزمایشگاه‌ها به صورت کاملا تعاملی طراحی شده‌اند تا کاربر بتواند احساس حضور در یک آزمایشگاه واقعی را تجربه نماید. در آزتو، دانشجو پس از ورود به وب‌سایت، آزمایش مورد نظر را انتخاب، ستاپ آزمایش را تهیه و پارامترهای ورودی را تعیین کرده و برنامه شبیه‌سازی را اجرا می‌نماید و سپس نتایج آزمایش را به صورت اعداد خروجی و یا نمودارهای گرافیكی مشاهده می‌نماید. نتایج را با توجه به دانش و استنباط خود تحلیل و دسته بندی نموده و گزارش آن را تهیه می‌کند.",
  },
  {
    id: 2,
    title: "آزتو چه اهدافی دارد؟",
    mainText:
      "تیم آزتو می‌خواهد فرآیند یادگیری را برای دانشجویان و دانش‌آموزان ایران زمین، در دسترس، هوشمند، موثر و فراگیر نماید. آزتو با استفاده از اصول گیمیفیکیشن باعث افزایش بازدهی کار و جلب علاقمندی کاربر شده و فرآیند انجام آزمایش را دلپذیر و لذت بخش می‌نماید. نکته قابل توجه دیگر افزایش سطح تعامل کاربر با سامانه با هدف یادگیری حداکثری است.",
  },
  {
    id: 3,
    title: "چگونه عضوی از آزتو بشوم؟",
    mainText:
      "برای اینکه در آزتو عضو شوید، عبارت azeto.ir را جستجو کنید. در منوی بالای سایت روی دکمه «ورود | ثبت‌نام» کلیک کنید. در گام اول شماره همراه خود را وارد کنید. در گام دوم کد پنج رقمی برای احراز هویت در اختیار شما قرار می‌گیرد، کد را ثبت کنید و در گام نهایی اطلاعات کاربری خود مانند نام، نام‌خانوادگی، کدملی، رمز عبور و تکرار آن را وارد نمایید و سپس این اطلاعات را ثبت کنید( برای دریافت راهنمای عضویت در سایت می‌توانید به ویدیو راهنمای عضویت در آزتو رجوع کنید).",
  },
  {
    id: 4,
    title: "آیا ثبت‌نام در آزتو هزینه دارد؟",
    mainText:
      "ثبت‌نام در آزتو هزینه‌ای ندارد و شما برای استفاده از آزمایش‌های غیر رایگان باید خرید اشتراک انجام دهید. ",
  },
  {
    id: 5,
    title: "رمز عبور را فراموش کرده‌ام، چه کاری باید انجام بدهم؟",
    mainText:
      "درصورتی که رمز عبور خود را فراموش کرده‌اید، در قسمت «ورود/ ثبت‌نام» روی دکمه «فراموشی رمز عبور»، کلیک کنید و مراحل تغییر رمز عبور را اجرا کنید.  ",
  },
  {
    id: 6,
    title: "برای خرید اشتراک باید در آزتو عضو شوم؟",
    mainText:
      "برای استفاده بهینه از آزتو در آن عضو شوید. اگر می‌خواهید اشتراک بخرید، پس از ثبت‌نام و ورود به حساب کاربری روی خرید اشتراک کلیک کنید. کد اشتراکی که در اختیار شما قرار گرفته است را وارد و ثبت کنید( برای دریافت راهنمای خرید اشتراک می‌توانید به راهنمای خرید اشتراک رجوع کنید). ",
  },
  {
    id: 7,
    title: "اشتراکی خریده‌ام اما نمی‌توانم استفاده کنم، چگونه پیگیری کنم؟",
    mainText:
      "اگر کد اشتراکی که در اختیار شما قرار گرفته است اعمال نشد، با مرجع اصلی خرید اشتراک تماس بگیرید و مرجع به پشتیبانی اطلاع دهد یا با پشتیبانی تماس بگیرید. ",
  },

  {
    id: 8,
    title:
      "اگر در مرحله خرید یا استفاده از آزتو سوال یا ابهامی داشته باشم، از چه کسی بپرسم؟",
    mainText:
      "هر گونه سوال، مشکل و ابهامی که در هنگام استفاده از آزتو برای شما وجود دارد را به پشتیبانی اطلاع دهید. ",
  },

  {
    id: 9,
    title: "چگونه از آزتو استفاده کنم؟",
    mainText:
      "برای استفاده از آزتو ابتدا به حساب کاربری خود وارد شوید، سپس در قسمت آزمایش‌های من روی مشاهده آزمایش کلیک کنید و وارد آزمایش دلخواه خود شوید. با کلیک روی تئوری، روش انجام، شبیه‌ساز، ویدئو، تمرین، آزمون و منابع وارد شوید و محتوای آن را مشاهده کنید و در قسمت گزارش‌کار برداشت و تحلیل خود را ثبت کنید( برای دریافت راهنمای استفاده از آزتو می‌توانید به ویدئو راهنمای استفاده از آزتو رجوع کنید). ",
  },

  {
    id: 10,
    title: "آیا می‌توانم به صورت رایگان محتوای آزمایشی را مشاهده کنم؟",
    mainText:
      "برخی از آزمایش‌های آزتو رایگان هستند و شما می‌توانید به آزتو وارد شوید و محتوای آن‌ها را مشاهده کنید، اما برای استفاده از محتوای موجود در آزمون، تمرین و شرکت در آن‌ها باید در حساب کاربری وارد شوید. برای استفاده بهینه از آزتو بهتر است که خرید اشتراک نمایید و سپس محتوای آزمایش‌ها را مشاهده کنید. ",
  },

  {
    id: 11,
    title: "استفاده از آزتو چقدر هزینه دارد؟",
    mainText:
      "تعدادی از آزمایش‌ها رایگان هستند و می‌توانید پس از ورود به آزتو و ثبت‌نام از آزمایش‌های رایگان استفاده کنید. برای آزمایش‌های غیر رایگان اشتراک تهیه کنید و هزینه آن‌ها در قسمت خرید اشتراک قابل مشاهده است. ",
  },
  {
    id: 12,
    title: "کدام آزمایش برای من مناسب است؟",
    mainText:
      "به آزتو وارد شوید سپس روی آزمایش‌ها کلیک کنید. موضوع و پایه تحصیلی خود را انتخاب کنید، آزمایش‌های متناسب با پایه تحصیلی و موضوع مورد نظر فعال خواهد شد. ",
  },
];
